import { render, staticRenderFns } from "./MultimediaChat.vue?vue&type=template&id=0cde7fc8&"
import script from "./MultimediaChat.vue?vue&type=script&lang=js&"
export * from "./MultimediaChat.vue?vue&type=script&lang=js&"
import style0 from "./MultimediaChat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports